export const APP_REFRESH_ID = 'app_refresh_id';
